<script lang="ts">
					import { defineComponent } from 'vue'
					export default defineComponent({
						name: "undefined"
					})
				</script><template>
	<router-view />
	<cool />
</template>

<script setup lang="ts">
import Cool from '/@/cool/index.vue';
</script>
